// extracted by mini-css-extract-plugin
module.exports = {"section":"OnePicture_section__oBAHP"};